import { Box, Stack } from '@mui/material'
import { roundingNumber } from 'components/shared/processes'
import { ReactElement } from 'react'
import { COLORS } from 'styles/colors'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographyPrimary16Bold } from 'ui/typography/TypographyPrimary16Bold'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

type GroupCardProps = {
	bulk: string
	count?: number | null
	ratio?: string
	description?: string
	descriptionTop?: string
	customElement?: ReactElement
	customTopDescription?: ReactElement
	verticalGap?: string
	isAlert?: boolean
}

const GroupCard = ({
	verticalGap = '8px',
	bulk,
	description,
	descriptionTop,
	customTopDescription,
	count,
	ratio,
	customElement,
	isAlert = false,
}: GroupCardProps) => {
	const roundedCount = count == null ? null : roundingNumber(count, 1)
	const hasCount = roundedCount != null && !Number.isNaN(roundedCount)

	return (
		<Stack
			direction='column'
			gap={verticalGap}
			sx={{
				padding: '16px',
				borderRadius: '8px',
				height: '100%',
				width: '100%',
				boxShadow: '0px 4px 16px 0px rgba(0, 0, 0, 0.08)',
				backgroundColor: 'white',
			}}
		>
			<Stack direction='row' justifyContent='space-between' alignItems='center'>
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'flex-start',
						flexWrap: 'wrap',
					}}
				>
					{customElement ? (
						customElement
					) : (
						<TypographyPrimary16Bold
							sx={{
								fontSize: 16,
								fontWeight: 600,
								color: isAlert ? COLORS.error : 'black',
							}}
						>
							{hasCount ? roundedCount : 'Нет данных'}
						</TypographyPrimary16Bold>
					)}
					{hasCount && ratio && (
						<TypographySecondary14 sx={{ pl: '4px' }}>
							{ratio}
						</TypographySecondary14>
					)}
				</Box>
				{customTopDescription ? (
					customTopDescription
				) : (
					<TypographySecondary14 sx={{ pl: '4px' }}>
						{descriptionTop}
					</TypographySecondary14>
				)}
			</Stack>
			<Stack direction='row' justifyContent='space-between'>
				<TypographyPrimary>{bulk}</TypographyPrimary>
				<TypographySecondary>{description}</TypographySecondary>
			</Stack>
		</Stack>
	)
}

export default GroupCard
